import React from 'react';
import AppEntry from './AppEntry';

function App(){
   return (<>
     <AppEntry />
    </>);
}

export default App;